@if (PrimaryTradeLicenseRequirementForms && (VendorTradeState || VendorTrade)) {
  <div class="modal-header">
    <div class="modal-title">
      <span class="lusm-eyebrow">License files</span>
      <h3 class="mb-0">
        {{
          VendorTradeState?.SubNationalDivision?.name ||
            PrimaryTradeLicenseRequirement!.SubNationalDivision?.name
        }}
      </h3>
      <p class="modal-subtitle mb-0">
        Upload an image of your valid trade license. It must cover every service
        performed in
        {{
          VendorTradeState?.SubNationalDivision?.name ||
            PrimaryTradeLicenseRequirement!.SubNationalDivision?.name
        }}.
      </p>
    </div>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="close()"
    ></button>
  </div>

  <div class="modal-body">
    <div
      class="lusm-dropzone"
      [class.lusm-dropzone--active]="!!DragDropPanelStyle"
      (dragenter)="fileDragEnter($event)"
      (dragleave)="fileDragLeave($event)"
      (dragover)="fileDragOver($event)"
      (drop)="fileDrop($event)"
    >
      <i class="bi bi-cloud-arrow-up lusm-dropzone__icon"></i>
      <p class="lusm-dropzone__title mb-0">Drag and drop file here</p>
      <p class="lusm-dropzone__hint mb-0">or</p>
      <button type="button" class="btn btn-primary" (click)="uploadFile()">
        <i class="bi bi-upload me-1"></i>
        Upload trade license
      </button>
      <input
        #fileUploadInput
        type="file"
        (change)="selectedFile($event)"
        hidden
      />
    </div>

    <div class="lusm-columns">
      <section class="lusm-column">
        <header class="lusm-column__head">
          <h4 class="mb-0">Uploaded files</h4>
          <span class="lusm-column__count">{{ (Licenses || []).length }}</span>
        </header>

        @if ((Licenses || []).length === 0) {
          <p class="lusm-empty">No license files uploaded yet.</p>
        }

        <app-display-card-column
          [displayCardPanelHeight]="'fit'"
          [itemCollection]="Licenses || []"
          [SelectedItems]="SelectedLicenseSet"
        >
          <ng-template let-item="item" let-index="index">
            <div
              class="lusm-license"
              [class.lusm-license--expired]="isLicenseExpired(item)"
              [class.lusm-license--selected]="SelectedLicense === item"
            >
              @if (isLicenseExpired(item)) {
                <span class="lusm-license__status">
                  <i class="bi bi-exclamation-triangle-fill"></i>
                  Expired
                </span>
              }
              <a
                class="lusm-license__file"
                (click)="downloadFile(item)"
                href="javascript:void(0)"
              >
                <i class="bi bi-file-earmark-text"></i>
                {{ item.licenseFileName }}
              </a>
              <div class="lusm-license__meta">
                @if (item.licenseFile) {
                  <span>{{
                    normalizeFileSizeText(item.licenseFile.length)
                  }}</span>
                } @else if (item.LicenseFile?.filesize) {
                  <span>{{
                    normalizeFileSizeText(item.LicenseFile.filesize)
                  }}</span>
                }
                @if (
                  (item.licenseFile || item.LicenseFile?.filesize) &&
                  item.licenseFileName
                ) {
                  <span>·</span>
                }
                @if (item.licenseFileName) {
                  <span>{{ item.licenseFileName.split('.').pop() }}</span>
                }
              </div>
              <div class="lusm-license__actions">
                <button
                  type="button"
                  class="lusm-license__icon-btn"
                  title="Replace file"
                  aria-label="Replace file"
                  (click)="changeImage()"
                >
                  <i class="bi bi-arrow-repeat"></i>
                </button>
                <input
                  #fileChangeInput
                  type="file"
                  (change)="changeFile($event, item)"
                  hidden
                />
                <button
                  type="button"
                  class="lusm-license__icon-btn lusm-license__icon-btn--danger"
                  title="Delete license"
                  aria-label="Delete license"
                  (click)="archiveLicense(item, index)"
                >
                  <i class="bi bi-trash"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-sm"
                  [class.btn-primary]="SelectedLicense !== item"
                  [class.btn-outline]="SelectedLicense === item"
                  (click)="selectLicense(item)"
                >
                  {{ SelectedLicense === item ? 'Cancel' : 'Assign license' }}
                </button>
              </div>
            </div>
          </ng-template>
        </app-display-card-column>
      </section>

      <section class="lusm-column">
        <header class="lusm-column__head">
          <h4 class="mb-0">
            {{
              !SelectedLicense ? 'Chosen trades' : 'Trades needing this license'
            }}
          </h4>
        </header>

        @if (SelectedLicense) {
          <p class="lusm-hint">
            Click a trade below to assign the highlighted license to it.
          </p>
        }

        @if (!SelectedLicense) {
          <app-display-card-column
            [displayCardPanelHeight]="'fit'"
            [itemCollection]="PrimaryTradeLicenseRequirementForms || []"
          >
            <ng-template let-item="item" let-index="index">
              <div class="lusm-trade">
                <h5 class="lusm-trade__name mb-0">
                  {{ item.controls['PrimaryTrade'].value.name }}
                </h5>
                @if (
                  item.controls['Licenses'] &&
                  item.controls['Licenses'].value.length === 1
                ) {
                  <p class="lusm-trade__file mb-0">
                    <i class="bi bi-file-earmark-text"></i>
                    {{ item.controls['Licenses'].value[0].licenseFileName }}
                  </p>
                  <button
                    type="button"
                    class="btn btn-outline btn-sm"
                    (click)="unassignLicense(item)"
                  >
                    Remove license
                  </button>
                } @else {
                  <span class="lusm-trade__status">
                    <i class="bi bi-exclamation-triangle-fill"></i>
                    Needs license
                  </span>
                }
              </div>
            </ng-template>
          </app-display-card-column>
        }

        @if (SelectedLicense) {
          <app-display-card-column
            [displayCardPanelHeight]="'fit'"
            [itemCollection]="getTradeRequirementFormsWithoutLicenses()"
            [cardStyle]="LicenseAssignmentCardStyle"
          >
            <ng-template let-item="item" let-index="index">
              <button
                type="button"
                class="lusm-trade-assign"
                (click)="assignLicense(item).subscribe()"
              >
                <i class="bi bi-plus-circle"></i>
                <span>{{ item.controls['PrimaryTrade'].value.name }}</span>
              </button>
            </ng-template>
          </app-display-card-column>
        }
      </section>
    </div>
  </div>

  <div class="modal-footer">
    <div class="action-row justify-end w-100">
      <button type="button" class="btn btn-primary" (click)="close()">
        <i class="bi bi-check-lg me-1"></i>
        Done
      </button>
    </div>
  </div>
}
